import React, { useState, useEffect } from 'react';
import { UitkSlider } from 'uitk-react-slider';

interface SliderInputProps {
  name: string;
  min: number;
  max: number;
  step: number;
  defaultValue: number;
  onChange: (evt: any) => any;
  disabled?:boolean
}

const SliderInput: React.FC<SliderInputProps> = ({
  name,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  defaultValue = 0,
  disabled=false,
}) => {
  const [inputState, setInputState] = useState(defaultValue);

  const handleBasicDualSliderChange = (val) => {
    setInputState(val);
  };

  useEffect(() => {
    onChange(inputState);
  }, [inputState]);

  return (
    <UitkSlider
      id={name}
      name={name}
      min={min}
      max={max}
      step={step}
      handleChange={(val) => handleBasicDualSliderChange(val)}
      value={inputState}
      ticks={false}
      disabled={disabled}
    />
  );
};

export  {SliderInput , SliderInputProps};
